<div *ngIf="availableLanguages.length >= 2" class="languages" ngClass.gt-md="large">
    <mat-chip-list>
      <mat-chip class="chip" *ngFor="let lang of availableLanguages"
                [selected]="lang === language"
                routerLink="/product-information/{{salesOrganization}}/{{lang}}/{{serialNumber}}">{{lang}}</mat-chip>
    </mat-chip-list>
  </div>